var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 9,
    viewBox: "0 0 29 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0858 6.58579L10.249 3.74903C8.86542 2.36542 8.17361 1.67361 7.36628 1.17888C6.6505 0.740249 5.87015 0.417015 5.05386 0.221041C4.13316 0 3.15479 0 1.19807 0H27.8019C25.8452 0 24.8668 0 23.9461 0.221041C23.1299 0.417015 22.3495 0.740249 21.6337 1.17888C20.8264 1.67361 20.1346 2.36542 18.751 3.74903L15.9142 6.58579C15.1332 7.36684 13.8668 7.36683 13.0858 6.58579Z",
    fill: "#1C1C1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8019 1C25.7976 1 24.9584 1.00643 24.1796 1.19341C23.4653 1.36489 22.7825 1.64772 22.1562 2.03152C21.4733 2.45003 20.8753 3.03887 19.4581 4.45614L16.6213 7.2929C15.4497 8.46447 13.5503 8.46446 12.3787 7.29289L9.54193 4.45614C8.12466 3.03887 7.52672 2.45003 6.84378 2.03152C6.21748 1.64772 5.53466 1.36489 4.82041 1.19341C4.04157 1.00643 3.20239 1 1.19807 1H0.5V0H1.19807C3.15479 0 4.13315 0 5.05386 0.221041C5.87015 0.417014 6.6505 0.74025 7.36628 1.17888C8.17361 1.67361 8.86542 2.36542 10.249 3.74903L13.0858 6.58579C13.8668 7.36683 15.1332 7.36684 15.9142 6.58579L18.751 3.74903C20.1346 2.36542 20.8264 1.67361 21.6337 1.17888C22.3495 0.74025 23.1299 0.417014 23.9461 0.221041C24.8668 0 25.8452 0 27.8019 0H28.5V1H27.8019Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTail);
export default __webpack_public_path__ + "static/media/tail.594ea9105e0cb32d58aabc8d745230da.svg";
export { ForwardRef as ReactComponent };